const actionTypes = {
  SET_LOGGED_IN: 'SET_LOGGED_IN',
  SET_USER: 'SET_USER',
  SET_MODULES: 'SET_MODULES',
  SET_ALLOWED_PATHS: 'SET_ALLOWED_PATHS',
};

export function setUser(user) {
  return { type: actionTypes.SET_USER, user };
}

export function setLoggedIn(loggedIn) {
  return { type: actionTypes.SET_LOGGED_IN, loggedIn };
}

export function setModules(modules) {
  return { type: actionTypes.SET_MODULES, modules };
}

export function setAllowedPaths(paths) {
  return { type: actionTypes.SET_ALLOWED_PATHS, paths };
}

export default function userReducer(
  state = { loggedIn: false, user: null, modules: null, allowedPaths: null },
  action
) {
  switch (action.type) {
    case actionTypes.SET_LOGGED_IN: {
      return { ...state, loggedIn: action.loggedIn };
    }
    case actionTypes.SET_USER: {
      return { ...state, user: action.user };
    }
    case actionTypes.SET_MODULES: {
      return { ...state, modules: action.modules };
    }
    case actionTypes.SET_ALLOWED_PATHS: {
      return { ...state, allowedPaths: action.paths };
    }
    default:
      return state;
  }
}

export const userSelector = (state) => state.userReducer.user;
export const loggedInSelector = (state) => state.userReducer.loggedIn;
